/** Students directory on volunteer student registration dashboard */
export const STUDENT_DIRECTORY_COLUMN_VISIBILITY_KEY =
  "girinestham.studentRegistration.columnVisibility";

export const STUDENT_DIRECTORY_PAGE_SIZE = 20;

export const STUDENT_DIRECTORY_COLUMN_DEFS = [
  { id: "code", label: "Student code", defaultVisible: true },
  { id: "full_name", label: "Full name", defaultVisible: true },
  { id: "date_of_birth", label: "Date of birth", defaultVisible: true },
  { id: "gender", label: "Gender", defaultVisible: false },
  { id: "contact_number", label: "Contact number", defaultVisible: true },
  { id: "email", label: "Email", defaultVisible: false },
  { id: "address", label: "Address", defaultVisible: false },
  { id: "guardian_name", label: "Guardian name", defaultVisible: false },
  { id: "emergency_contact", label: "Emergency contact", defaultVisible: false },
  { id: "sport_name", label: "Interested sport", defaultVisible: true },
  { id: "created_at", label: "Date of joining", defaultVisible: true },
  { id: "mem_registration_date", label: "Membership registration date", defaultVisible: true },
  { id: "membership_name", label: "Membership plan", defaultVisible: false },
];

export const STUDENT_DIRECTORY_SORTABLE_COLUMNS = [
  { prop: "code", label: "Student code" },
  { prop: "full_name", label: "Full name" },
  { prop: "date_of_birth", label: "Date of birth" },
  { prop: "gender", label: "Gender" },
  { prop: "contact_number", label: "Contact number" },
  { prop: "email", label: "Email" },
  { prop: "address", label: "Address" },
  { prop: "guardian_name", label: "Guardian name" },
  { prop: "emergency_contact", label: "Emergency contact" },
  { prop: "sport_name", label: "Interested sport" },
  { prop: "created_at", label: "Date of joining" },
  { prop: "mem_registration_date", label: "Membership registration date" },
  { prop: "membership_name", label: "Membership plan" },
];
